import React from 'react'

import {
  CCol,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CModal,
  CFormSwitch,
  CFormTextarea,
} from '@coreui/react'

import { MultiRequest } from '../../../store/actions/multicontent'
import { ErrorToast, SuccesToast } from 'src/components/toaster'

import { connect } from 'react-redux'
import { Form, Field } from 'react-final-form'
import createDecorator from 'final-form-calculate'
import { request } from 'src/helpers/request'
import { formatRupiah } from 'src/module/helpers'
import PasswordField from '../../../components/PasswordField'
import TextRemove from '../../../components/TextRemove'
// import NewSwitch from '../../../components/NewSwitch'

// import CheckSelect from '../../../components/CheckSelect'

const NewSwitch = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../../components/NewSwitch'),
)
const RadioSelect = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../../components/RadioSelect'),
)
const CheckSelect = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../../components/CheckSelect'),
)
const TextMaskNpwp = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../../components/TextMaskNpwp'),
)

const DateNonYears = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../../components/DateNonYears'),
)

const BasicDateTimePicker = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/DatePickerMui'),
)
const TextMaskHandphone = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/TextMaskHandphone'),
)
const CheckBox = React.lazy(() =>
  import(/* webpackPrefetch: true */ '../../../components/CheckBox'),
)
const TextMask = React.lazy(() => import(/* webpackPrefetch: true */ 'src/components/TextMask'))
const Select = React.lazy(() => import(/* webpackPrefetch: true */ 'src/components/Select'))

const SwitchSelect = React.lazy(() => import(/* webpackPrefetch: true */ 'src/components/Switch'))
const MultiSelectPure = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/MultiSelectPure'),
)
const RupiahSelector = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/RupiahSelector'),
)
const DatePickerComponent = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/DatePicker'),
)
const IconSelector = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/IconSelector'),
)
const MultiSelect = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/MultiSelect'),
)
const Preloader = React.lazy(() => import(/* webpackPrefetch: true */ 'src/components/Preloader'))

const FormAttachment = React.lazy(() =>
  import(/* webpackPrefetch: true */ 'src/components/FormAttachment'),
)

export const required = (caption) => (value) => value ? undefined : `${caption} belum terisi..`

export const emailValidation = (caption) => (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    return `${caption} belum terisi..`;
  }
  if (!emailRegex.test(value)) {
    return `${caption} tidak valid..`;
  }
  return undefined;
};

export const composeValidators =
  (...validators) =>
    (value) => {
      return validators.reduce((error, validator) => error || validator(value), undefined)
    }

export const mustBeNumber = (value) =>
  isNaN(value) ? 'Yang di tuliskan harus berupa angka' : undefined

const form_pemakaian = [
  {
    name: 'id_pakai',
    type: 'text',
    label: 'ID Pemakaian',
    readOnly: true,
    layOut: 'formGroupHorizontal',
    validate: required('ID Pemakaian'),
  },
  {
    name: 'id_pelanggan',
    type: 'virtual_select',
    label: 'Pelanggan',
    layOut: 'formGroupHorizontal',
    data: [],
    validate: required('Pelanggan'),
  },
  {
    layOut: 'formGroupVertical',
    label: 'Bulan dan Tahun',
    htmlFor: 'formGroupVertical',
    content: [
      {
        name: 'bulan',
        type: 'select',
        placeholder: ' -- Pilih Bulan --',
        data: [],
        validate: required('Bulan'),
      },
      {
        name: 'tahun',
        type: 'text',
        readOnly: true,
        size: 'sm',
      },
    ],
  },
  {
    name: 'id_layanan',
    type: 'select',
    label: 'Jenis Layanan',
    data: [],
    readOnly: true,
    layOut: 'formGroupHorizontal',
  },
  {
    name: 'tafsiran_pembayaran',
    type: 'text',
    label: 'Tafsiran Tagihan',
    readOnly: true,
    layOut: 'formGroupHorizontal',
  },
]

export const renderFieldForm = ({
  input,
  meta,
  metatype,
  item,
  layOut,
  customRender,
  className,
  readOnly,
  allValues,
  autoFocus,
}) => {
  let Output = <div></div>

  if (customRender) {
    return React.cloneElement(customRender, { input, meta, allValues, data: item?.data, readOnly, item })
  }
  /* Berikan input.onChange null saat form sudah berapa pada readOnly saat form berapa pada posisi edit */
  switch (metatype) {
    case 'password':
    case 'text':
    case 'number':
      Output = (
        <CFormInput
          {...(autoFocus && {
            autoFocus: 'autofocus',
          })}
          name={input.name}
          /* adding support placeholder on 30 JUNI 2022 */
          placeholder={item.placeholder || item.label}
          readOnly={readOnly}
          size={item.size}
          type={metatype}
          {...input}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'text_remove':
      Output = (
        <TextRemove
          {...(autoFocus && {
            autoFocus: 'autofocus',
          })}
          name={input.name}
          /* adding support placeholder on 30 JUNI 2022 */
          placeholder={item.placeholder || item.label}
          readOnly={readOnly}
          size={item.size}
          type={metatype}
          inputProps={input}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'password_mui':
      Output = (
        <PasswordField
          {...(autoFocus && {
            autoFocus: 'autofocus',
          })}
          name={input.name}
          /* adding support placeholder on 30 JUNI 2022 */
          placeholder={item.placeholder || item.label}
          readOnly={readOnly}
          size={item.size}
          type={metatype}
          inputProps={input}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break

    case 'file':
      Output = (
        <FormAttachment
          {...(autoFocus && {
            autoFocus: 'autofocus',
          })}
          name={input.name}
          /* adding support placeholder on 30 JUNI 2022 */
          placeholder={item.placeholder || item.label}
          readOnly={readOnly}
          size={item.size}
          type={metatype}
          inputProps={input}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break

    case 'mask':
      Output = (
        <TextMask
          name={input.name}
          /* adding support placeholder on 30 JUNI 2022 */
          placeholder={item.placeholder || item.label}
          size={item.size}
          mask={item.mask}
          {...{
            inputProps: input,
          }}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'mask_npwp':
      Output = (
        <TextMaskNpwp
          name={input.name}
          /* adding support placeholder on 30 JUNI 2022 */
          placeholder={item.placeholder || item.label}
          size={item.size}
          {...{
            inputProps: input,
          }}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'phone':
      Output = (
        <TextMaskHandphone
          name={input.name}
          /* adding support placeholder on 30 JUNI 2022 */
          placeholder={item.placeholder || item.label}
          size={item.size}
          mask={item.mask}
          {...{
            inputProps: input,
          }}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'textarea':
      Output = (
        <CFormTextarea
          name={input.name}
          placeholder={item?.placeHolder || item.label}
          readOnly={item.readOnly}
          size={item.size}
          type={metatype}
          rows={item.rows || '2'}
          {...input}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'rupiah':
      Output = (
        <RupiahSelector
          name={input.name}
          placeholder={item.label}
          readOnly={item.readOnly}
          size={item.size}
          type={metatype}
          autoFocus={autoFocus}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'switch':
      Output = (
        <SwitchSelect
          name={input.name}
          placeholder={item.label}
          readOnly={item.readOnly}
          size={item.size}
          type={metatype}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'new_switch':
      Output = (
        <NewSwitch
          name={input.name}
          placeholder={item.label}
          readOnly={item.readOnly}
          size={item.size}
          type={metatype}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'checkbox':
      // if (input.name === 'enable_vlan') {
      //   console.log(input)
      // }

      Output = (
        <CheckBox
          name={input.name}
          placeholder={item.label}
          readOnly={item.readOnly}
          size={item.size}
          type={metatype}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'virtual_select':
      Output = (
        <Select
          name={input.name}
          placeholder={item.label}
          data={item.data}
          readOnly={item.readOnly}
          formatOptionLabel={item?.formatOptionLabel}
          classNamePrefix={item?.classNamePrefix}
          optionHeight={item?.optionHeight}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
            ...(item.disabled && {
              onChange: null,
            }),
          }}
          disabled={item.disabled || item.readOnly}
        />
      )
      break
    case 'icon_selector':
      Output = (
        <IconSelector
          name={input.name}
          placeholder={item.label}
          data={item.data}
          readOnly={item.readOnly}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'is_multi_select_khusus_menu':
      Output = (
        <MultiSelect
          khususMenu
          name={input.name}
          placeholder={item.label}
          data={item.data}
          readOnly={item.readOnly}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'is_multi_select':
      Output = (
        <MultiSelectPure
          name={input.name}
          placeholder={item.label}
          data={item.data}
          readOnly={item.readOnly}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'date':
      Output = (
        <DatePickerComponent
          name={input.name}
          placeholder={item.label}
          data={item.data}
          showTimeSelect={item.showTimeSelect}
          readOnly={item.readOnly}
          size={item.size}
          useMinDate={item?.useMinDate}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'date_non_years':
      Output = (
        <DateNonYears
          name={input.name}
          placeholder={item.label}
          data={item.data}
          showTimeSelect={item.showTimeSelect}
          readOnly={item.readOnly}
          size={item.size}
          useMinDate={item?.useMinDate}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'date_time':
      Output = (
        <DateNonYears
          name={input.name}
          placeholder={item.label}
          data={item.data}
          showTimeSelect
          readOnly={item.readOnly}
          size={item.size}
          useMinDate={item?.useMinDate}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'date_mui':
      Output = (
        <BasicDateTimePicker
          name={input.name}
          placeholder={item.label}
          data={item.data}
          showTimeSelect={item.showTimeSelect}
          readOnly={item.readOnly}
          size={item.size}
          inputProps={{
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          }}
        />
      )
      break
    case 'select':
      if (item.component) {
        Output = React.createElement(item.component, {
          inputProps: {
            ...input,
            ...(item.readOnly && {
              onChange: null,
            }),
          },
          item,
          allValues,
          // readOnly: item.readOnly
        })
      } else {
        Output = (
          <CFormSelect
            size={item?.size || 'sm'}
            aria-label={item.placeholder}
            disabled={item.readOnly}
            {...input}
            {...(item.readOnly && {
              onChange: null,
            })}
          >
            {item.placeholder && <option value="">{item.placeholder}</option>}
            {item.data?.map((sItem, sIndex) => (
              <option key={sIndex} value={sItem.value}>
                {sItem.label}
              </option>
            ))}
          </CFormSelect>
        )
      }

      break
    case 'radio_select':
      // if (input?.name === '')
      Output = (
        <RadioSelect
          size={item?.size || 'sm'}
          aria-label={item.placeholder}
          readOnly={item.readOnly}
          inputProps={input}
          data={item.data}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'check_select':
      Output = (
        <CheckSelect
          size={item?.size || 'sm'}
          aria-label={item.placeholder}
          disabled={item.readOnly}
          inputProps={input}
          data={item.data}
          inline={item.inline}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break
    case 'checked':
      Output = (
        <CFormSwitch
          size="xl"
          label={item.placeholder}
          name={input.name}
          id="formSwitchCheckDefaultXL"
          {...input}
          {...(item.readOnly && {
            onChange: null,
          })}
        />
      )
      break

    default:
      break
  }
  /* 
          <div className="mb-3">
                                        <CFormLabel htmlFor="exampleFormControlInput1">Bulan Dan Tahun</CFormLabel>
                                        <div className="input-group">
                                            
                                            <CFormInput size='sm' />
                                        </div>
                                    </div>
    */

  const error_component = (
    <React.Fragment>
      {meta.error && meta.touched && (
        <span>
          <CFormFeedback className="d-block" invalid>
            {meta.error}
          </CFormFeedback>
        </span>
      )}
    </React.Fragment>
  )
  const validating = (
    <React.Fragment>
      {meta.validating && (
        <React.Fragment>
          <React.Fragment>
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="spinner-grow spinner-grow-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </React.Fragment>
        </React.Fragment>
      )}
    </React.Fragment>
  )
  return (
    <React.Fragment>
      {layOut === 'formGroupHorizontal' && (
        <div className={`${item.size}` || 'mb-1'}>
          <CFormLabel className={item.size} htmlFor="exampleFormControlInput1">
            {item.label}
          </CFormLabel>
          {Output}
          {error_component}
        </div>
      )}
      {!layOut && (
        <div className={className}>
          {Output}
          {error_component}
          {validating}
        </div>
      )}
      {layOut === 'inline_mode' && (
        <div className="mb-1 row">
          <label htmlFor={item?.name} className="col-sm-4">
            {item?.label}
          </label>
          <div className="col-sm-8">
            {Output}
            {error_component}
            {validating}
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

class TambahPemakaian extends React.Component {
  constructor(props) {
    super(props)
    // const [visibleLg, setVisibleLg] = useState(false)
    // const { vi}
    const { location } = props

    const urlSearchParams = new URLSearchParams(location.search)
    const params = Object.fromEntries(urlSearchParams.entries())

    this.state = {
      visibleLg: params.method === 'new',
      data: {
        id_pelanggan: [],
        bulan: [],
      },
      initialValues: {
        tahun: new Date().getFullYear(),
      },
    }
    this.ambilDataPemakaian()
  }

  ambilDataPemakaian = () => {
    const { dispatch } = this.props
    dispatch(
      MultiRequest('tambah_pemakaian', {
        method: 'get',
        url: '/pemakaian/tambah_pemakaian_query?with_data_pelanggan=true',
      }),
    )
  }

  componentDidUpdate(prevProps) {
    if (this.props?.axiosTemp['tambah_pemakaian'] !== prevProps?.axiosTemp['tambah_pemakaian']) {
      if (this.props?.axiosTemp['tambah_pemakaian']?.status === 'success') {
        const { response } = this.props?.axiosTemp['tambah_pemakaian']
        /* 
                    const options = Array.from(new Array(1000), (_, index) => ({
                        label: `Item ${index}`,
                        value: index
                    }));

                */
        let { id_pelanggan, bulan, nominal, id_layanan, ...anotherRes } = response

        id_pelanggan = id_pelanggan.map((item) => ({
          label: `${item.id_pelanggan} - ${item.nama_pelanggan}`,
          value: item.id_pelanggan,
        }))

        id_layanan = id_layanan.map((item) => ({
          label: `${item.layanan}`,
          value: item.id_layanan,
        }))

        bulan = bulan.map((item) => ({
          label: item.nama_bulan,
          value: item.id_bulan,
        }))

        this.setState({
          data: {
            id_pelanggan: id_pelanggan,
            bulan,
            id_layanan,
            realPelanggan: response.id_pelanggan,
            realLayanan: response.id_layanan,
          },
          initialValues: {
            ...this.state.initialValues,
            ...anotherRes,
          },
        })
      }
      if (this.props?.axiosTemp['tambah_pemakaian']?.status === 'error') {
        ErrorToast('Pengambilan data pertama gagal')
      }
    }
    if (
      this.props?.axiosTemp[this.props.selectorRedux] !==
      prevProps?.axiosTemp[this.props.selectorRedux]
    ) {
      if (
        this.props?.axiosTemp[this.props.selectorRedux]?.status === 'success' &&
        this.props?.axiosTemp[this.props.selectorRedux].lastaction?.method === 'post'
      ) {
        SuccesToast('Penyimpanan data baru berhasil')
      }
      if (
        this.props?.axiosTemp[this.props.selectorRedux]?.status === 'error' &&
        this.props?.axiosTemp[this.props.selectorRedux].lastaction?.method === 'post'
      ) {
        ErrorToast('Penyimpanan data gagal ..')
      }
    }
  }
  renderInitialValues = (initialValues) => {
    let new_initialValues = {
      ...initialValues,
    }
    if (initialValues.id_pelanggan) {
      new_initialValues = {
        ...initialValues,
        id_pelanggan: initialValues?.id_pelanggan.value,
      }
    }
    return new_initialValues
  }
  onSubmit = (initialValues) => {
    const { dispatch } = this.props
    const _initialValues = this.renderInitialValues(initialValues)

    dispatch(
      MultiRequest(this.props.selectorRedux, {
        method: 'post',
        url: '/pemakaian/simpan',
        dataPost: {
          data: {
            ..._initialValues,
          },
          method: 'new',
        },
      }),
    )
  }

  updateDataForm = (form = [], data) => {
    let _form = form
    const accessor = ['id_pelanggan', 'bulan', 'id_layanan']

    function genContent(content, data) {
      let _content = content.map((sItem) => ({
        ...sItem,
        ...(accessor.includes(sItem.name) && {
          data: data[sItem.name],
        }),
      }))

      return _content
    }
    _form = form.map((item) => {
      return {
        ...item,
        ...(accessor.includes(item.name) && {
          data: accessor.includes(item.name) ? data[item.name] : [],
        }),
        ...(Array.isArray(item.content) && {
          test: 'haus',
          content: genContent(item.content, data),
        }),
      }
    })

    return _form
  }

  onClose = () => {
    const { history, location } = this.props
    history.push(location.pathname)
  }

  render() {
    const { axiosTemp } = this.props
    const { data } = this.state

    const is_modal = this.props.location?.query?.method

    let _form = this.updateDataForm(form_pemakaian, this.state.data)

    let initialValues = this.state.initialValues

    const calculator = createDecorator(
      {
        field: 'id_pelanggan', // when minimum changes...
        updates: {
          // ...update maximum to the result of this function
          awal: async (id_pelanggan, allValues) => {
            try {
              const res = await request(
                'get',
                `/pemakaian/tambah_pemakaian_query?id_pelanggan=${id_pelanggan?.value}`,
              )
              return res.data?.awal || 0
            } catch (error) {
              return 0
            }
            // return 'test'
          },
          id_layanan: (values, allValues) => {
            // console.log(id_pelanggan)
            const { value } = values
            // console.log(value)
            // console.log(values)
            if (value) {
              const dt = data.realPelanggan
                .filter((item) => item.id_pelanggan === value)
                .reduce(
                  (prev, next) => ({
                    ...prev,
                    ...next,
                  }),
                  {},
                )
              // console.log(dt)
              return dt?.id_layanan
            }

            // console.log(allValues)
          },
          tafsiran_pembayaran: (values, allValues) => {
            // console.log(id_pelanggan)
            const { value } = values
            // console.log(value)
            // console.log(values)
            if (value) {
              const dt = data.realPelanggan
                .filter((item) => item.id_pelanggan === value)
                .reduce(
                  (prev, next) => ({
                    ...prev,
                    ...next,
                  }),
                  {},
                )
              // console.log(dt)
              const id_layanan = dt?.id_layanan

              const dh = data.realLayanan
                .filter((item) => item.id_layanan === id_layanan)
                .reduce(
                  (prev, next) => ({
                    ...prev,
                    ...next,
                  }),
                  {},
                )

              return formatRupiah(dh?.tarif, true)
              // console.log(data.realLayanan)
            }

            console.log(allValues)
          },
        },
      },
      // {
      //     field: 'akhir', // when maximum changes...
      //     updates: {
      //         // update minimum to the result of this function
      //         pakai: (akhirValue, allValues) =>
      //             Number(akhirValue) - Number(allValues.awal)
      //     }
      // },
    )

    // console.log(axiosTemp)

    return (
      <React.Fragment>
        {axiosTemp[this.props.selectorRedux]?.status === 'running' && <Preloader />}

        <React.Fragment>
          <CModal backdrop="static" size="lg" visible={is_modal} onClose={() => this.onClose()}>
            <div className="w-100 p-2 d-flex align-items-end bg-primary rounded-top rounded-end">
              <span className="text-white fw-bolder">Tambah Pemakaian</span>
              <div className="ms-auto">
                <button
                  className="btn-close btn-close-white fw-bolder"
                  onClick={() => this.onClose()}
                ></button>
              </div>
            </div>

            <Form
              decorators={[calculator]}
              initialValues={initialValues}
              onSubmit={this.onSubmit}
              render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit}>
                  <div className="p-2">
                    {_form.map((item, index) => {
                      if (item.content && item.layOut === 'formGroupVertical') {
                        return (
                          <div className="mb-3" key={index}>
                            <CFormLabel htmlFor={item?.htmlFor}>{item.label}</CFormLabel>
                            <div className="input-group">
                              {item.content?.map((xContent, xIndex) => (
                                <Field
                                  key={xIndex}
                                  layOut={xContent.layOut}
                                  item={xContent}
                                  metatype={xContent.type}
                                  name={xContent.name}
                                  component={renderFieldForm}
                                  readOnly={xContent.readOnly}
                                  validate={xContent.validate}
                                  className={`col-${12 / item.content.length}`}
                                />
                              ))}
                            </div>
                          </div>
                        )
                      }
                      if (item.layOut === 'formGroupHorizontal') {
                        return (
                          <Field
                            validate={item.validate}
                            item={item}
                            key={index}
                            metatype={item.type}
                            name={item.name}
                            layOut={item.layOut}
                            component={renderFieldForm}
                            readOnly={item.readOnly}
                          />
                        )
                      }
                      return <div key={index}>Belum Mengisi Layout</div>
                    })}
                  </div>

                  <div className="modal-footer">
                    <CCol xs="auto">
                      <button
                        className="btn btn-sm btn-primary"
                        type="submit"
                        disabled={submitting}
                        style={{ marginRight: '10px' }}
                      >
                        Simpan
                      </button>
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => this.onClose()}
                      >
                        Kembali
                      </button>
                    </CCol>
                  </div>
                </form>
              )}
            />
          </CModal>
        </React.Fragment>
      </React.Fragment>
    )
  }
}

const MapStateToProps = (state) => {
  return {
    axiosTemp: state.axiosTemp,
  }
}
const ts = connect(MapStateToProps)(TambahPemakaian)

export default React.memo(ts)
